export const selectReviews = () => {
	return process.env.REACT_APP_REVIEWS_FROM_SERVER
}

export const getTeacherReviews = (teacher) => teacher?.reviews || []

export const getReviewCount = (teacher) => getTeacherReviews(teacher)?.length || 0

export const getReviewRating = (review) => {
	return process.env.REACT_APP_REVIEWS_FROM_SERVER ? review?.rating : review?.feedback_rating 
}

export const getReviewMessage = (review) => {
	return process.env.REACT_APP_REVIEWS_FROM_SERVER ? review?.message : review?.feedback_message
}

export const getReviewUserName = (review) => {
	return process.env.REACT_APP_REVIEWS_FROM_SERVER ? review?.user_name : review?.user?.name
}

export const getReviewUserAvatar = (review) => {
	return process.env.REACT_APP_REVIEWS_FROM_SERVER ? review?.user_avatar : review?.user?.avatar
}

export const getTeacherRating = (teacher) => {
	const reviews = getTeacherReviews(teacher)

	if (!reviews?.length) return 5

	const totalRating = reviews.reduce((sum, review) => sum + Number(getReviewRating(review) || 0), 0)

	return (totalRating / reviews.length).toFixed(1)
}

export const getAppointmentCount = (teacher) => {
	return process.env.REACT_APP_REVIEWS_FROM_SERVER ? (teacher?.appointments_count < getReviewCount(teacher) ? getReviewCount(teacher) + 2 : teacher?.appointments_count) : teacher?.appointments_count
}
